import { render, staticRenderFns } from "./ClickableIconSm.vue?vue&type=template&id=47dae938"
import script from "./ClickableIconSm.vue?vue&type=script&lang=ts"
export * from "./ClickableIconSm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports